import { useEffect, useState } from 'react';

/**
 * Delays propagating a fast-changing value.
 *
 * Used for search inputs: without it, every keystroke would issue a request, so
 * typing "haroon" fires six queries whose results arrive out of order.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
